export default "__VITE_ASSET__DEVe0H9L__"